import React from "react";

import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Panel, PanelHeader } from "../../components/panel/panel.jsx";

import TableReact, { SelectColumnFilter } from "../../components/table/Table";
import _ from "lodash";
import { formatDate, formatMoney } from "../../helper/formatter.js";

const RegistroCobros = () => {
    const pagos = useSelector((state) => state.pago.items) || {};
    const customPagos = _(pagos).values().orderBy(["id"], ["desc"]).value();
    const tercero = useSelector((state) => state.tercero.items) || {};

    const columns = React.useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
                canGroupBy: false,
                disableFilters: true,
                width: 10,
                Cell: ({ row }) => {
                    return (
                        <Link to={`/venta/registro_cobros/${row.original?.id}`} className="fw-bold text-nowrap">
                            {row.original?.id}
                        </Link>
                    );
                },
            },
            {
                Header: "FECHA EMISION",
                id: "fecha_emision",
                accessor: (row) => formatDate(row.fecha_emision),
                canGroupBy: false,
                width: 20,
            },
            {
                id: "tercero",
                Header: "TERCERO",
                accessor: (row) => tercero[row.terceroId]?.razonsocial || "-",
                canGroupBy: false,
                minWidth: 300,
                width: 400,
            },
            {
                id: "tipo",
                Header: "TIPO PAGO",
                accessor: (row) => row.tipo_pago?.name,
                canGroupBy: false,
                Filter: SelectColumnFilter,
                width: 20,
            },
            {
                Header: "IMPORTE",
                accessor: "importe",
                Cell: ({ row }) => <div className="text-end text-nowrap">{formatMoney(row.original?.importe)}</div>,
                canGroupBy: false,
                width: 20,
            },
        ],
        [tercero, pagos]
    );

    const data = React.useMemo(() => customPagos, [pagos]);

    return (
        <Panel>
            <PanelHeader>Listado de cobros registrados</PanelHeader>
            <TableReact columns={columns} data={data} />
        </Panel>
    );
};

export default RegistroCobros;
